<template>
  <button-control
    size="small"
    type="secondary"
    :is-block="true"
    @click.prevent="openModal"
  >
    Заказать звонок
    <portal to="CallOrderModalD">
      <modal-vue-d
        :name="modalName"
        width="630"
        @opened="handlerOpendModal"
        @closed="handlerClosedModal"
      >
        <form-callback-d @need-proof="handlerNeedProof" />
      </modal-vue-d>
    </portal>
  </button-control>
</template>

<script>
import { ButtonControl } from '@book24/ui-components';

import ModalVueD from '@/js/vue/ModalVueD';
import FormCallbackD from '@/js/vue/Callback/form/CallbackFrom';

import CallOrderButtonMixin from '@/js/vue/Callback/buttons/CallOrderButtonMixin';

export default {
  name: 'CallOrderHeaderDNew',
  components: {
    ModalVueD,
    FormCallbackD,
    ButtonControl,
  },
  mixins: [CallOrderButtonMixin],
};
</script>
